import type { Persona } from './session.types'

/**
 * Extracted from `ContextSwitcher.tsx` (TT-V11 Phase 1, T07) — Overview's "{Client} · Action
 * Center" header needs the exact same active-org label the Navbar's context switcher already
 * shows, not a second computation that could read differently for the same context.
 */
export const PERSONA_LABEL: Record<Persona, string> = {
  SA: 'Service Admin',
  AGENCY: 'Agency',
  CLIENT: 'Client',
  VENDOR: 'Vendor',
  WORKER: 'Worker',
}

export interface Labelable {
  persona: Persona
  contextTenantId: string
  displayName?: string | null
}

/**
 * The persona text for a context. `persona` can be outside the `Persona` union at runtime
 * (`normalizePersona` passes unknown values such as ENTITY through), so a missing entry falls back
 * to the raw value instead of rendering "undefined". Existing labels are unchanged.
 */
export function contextPersonaLabel(persona: Persona): string {
  return PERSONA_LABEL[persona] ?? persona
}

/** Prefer the resolved org name; fall back to `persona · {tenantId}` (handover §3). */
export function contextLabel(ctx: Labelable): string {
  return ctx.displayName?.trim() || `${contextPersonaLabel(ctx.persona)} · ${ctx.contextTenantId.slice(0, 8)}`
}
